import { render, staticRenderFns } from "./arviointityokalut-modal-content.vue?vue&type=template&id=6d9101fc&"
import script from "./arviointityokalut-modal-content.vue?vue&type=script&lang=ts&"
export * from "./arviointityokalut-modal-content.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports